// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes, Component } from 'react';
import _ from 'lodash';
import TextArea from '../../../../../common/components/c_TextArea';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';
import TextField from '../../../../../common/components/c_TextField';
import prettyMoney from '../../../../../lib/prettyMoney';
import { connect } from 'react-redux';
import { get } from 'lodash';

const hourlyRateAcceptableMenuItems = [
  {
    value: 'true',
    primaryText: 'Yes',
    subElement: 'hourlyRateAcceptable'
  },
  {
    value: 'false',
    primaryText: 'No',
    subElement: 'hourlyRateAcceptable'
  },
];

const hasWorkedRemotelyMenuItems = [
  { value: true, primaryText: 'Yes' },
  { value: false, primaryText: 'No' }
];

const textFieldStyle = {
  margin: '-8px 0 2px',
  width: '100%',
  height: '100px',
  minHeight: '100px',
  lineHeight: '1.63',
};

const dropDownCustomization = {
  labelStyle: {
    padding: 0,
    margin: 0
  },
  underlineStyle: {
    marginLeft: 0
  },
  containerStyle: {
    width: '25%'
  }
};

@connect(store => {
  return {
    labels: get(store, 'labels.ExplanationOfWahve', {})
  };
})
export default class ExplanationOfWahve extends Component {
  static propTypes = {
    applicant: PropTypes.object,
    saveData: PropTypes.func,
    model: PropTypes.string.isRequired,
    script: PropTypes.bool,
    labels: PropTypes.object
  };

  constructor() {
    super();
    this.state = { values: {} };
  }

  onChange(property, event, value, name) {

    if(property === 'hourlyRateAcceptable') {
       event.target.value = prettyMoney(event.target.value).substring(0, 3);
    }

    value = name ? { id: value, name } : value;
    const values = _.assign({}, this.state.values, { [property]: value });
    this.setState({ values });
  }

  // handles tempState updates
  onBlur(property, event, value, name) {
    // handle dropdown

    if(property === 'desiredHourlyRate') {
       value = value.replace(/[^0-9\.]/g, '') || 0;
    }
    else {
      value = !_.isBoolean(value) && _.isEmpty(value) ? ' ' : value;
    }

    value = name ? { id: value, name } : value;
    const values = _.assign({}, this.state.values, { [property]: value });
    this.setState({ values }, () => {
          this.props.saveData(_.set({}, `${this.props.model}.${property}`, value));
    });
  }

  getValue = (propertyName) => {

      const profile =  _.get(this.props.applicant, 'profile');
      const value = _.get(this.state.values, propertyName,  profile[propertyName]);

      return value;
  }

  handleTextArea = (propertyName, text) => {

      const value = this.getValue(propertyName);

      return {
          'data-id': propertyName,
          text,
          value,
          onChange: this.onChange.bind(this, propertyName),
          onBlur: this.onBlur.bind(this, propertyName),
      };
  }

    handleTextField = (propertyName, text) => {

      const value = this.getValue(propertyName);

      return {
          dataId: propertyName,
          text,
          value,
          onChange: this.onChange.bind(this, propertyName),
          onBlur: this.onBlur.bind(this, propertyName),
      };
  }


  handleDropdown = (propertyName, text, menuItems) => {

    const value = this.getValue(propertyName);

    return {
        'data-id': propertyName,
        value,
        text,
        menuItems,
        onChange: this.onBlur.bind(this, propertyName),
    };

  }
  render() {
    const { script, applicant } = this.props;
    const { values } = this.state;

    return (
      <div className='expanded-accordion-content explanation-of-wahve'
        key={`explanation-of-wahve ${applicant.profile.id}`}>
        {
          // hide text when script disabled
          script &&
          <div>
            <div className='speaking-callout'>
              {`Now I'd like to tell you about WAHVE`}
            </div>
            <ul className='instructions-list'>
              {this.props.labels.explanationSection.map((listItemText, headerKey) =>
                <li className='instructions-list-item' key={headerKey}>{listItemText}</li>
              )}
              <li className='instructions-list-item'>
                Please refer to the <a href='https://wahve-my.sharepoint.com/personal/chrissy_tadlock_wahve_com/_layouts/OneNote.aspx?id=%2fpersonal%2fchrissy_tadlock_wahve_com%2fDocuments%2fNotebooks%2fWAHVE+Procedures&wd=target(Placement.one%7c328AEB29-9DF9-4884-B5BB-ABE8E73F1FB8%2fPay%5c%2fBill+Rates%7c1C47DFAF-88A1-4E9A-8FA1-395A45066239%2f)&xsdata=MDV8MDJ8YWRhbS5zdGllcmxlQHdhaHZlLmNvbXwwODkyOTU1YzgxODI0Y2I2OTRlZTA4ZGNhMmIwMTA5Znw1YTUyNDlhY2MzN2U0NTZjOTAzNjQ4NDc0Y2YxNzZjOHwwfDB8NjM4NTY0MTI0Mjc5MzYwNTAwfFVua25vd258VFdGcGJHWnNiM2Q4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazFoYVd3aUxDSlhWQ0k2TW4wPXwwfHx8&sdata=MlFDYVlSNVNReTFncFVkWWN6Q3AvMzl5WFEwdkJyUms0NjJaME15K0tkOD0%3d'>pay rates</a> for more information.
              </li>
            </ul>
          </div>
        }

        <ul className='instructions-list' style={{ paddingBottom: !script ? '15px' : null }}>

          <DropdownItem {...this.handleDropdown('hourlyRateAcceptable', 'Is the hourly rate range acceptable?', hourlyRateAcceptableMenuItems)} />
          <TextFieldItem
            defaultValue={prettyMoney(applicant.profile.desiredHourlyRate)}
            className='desired-hourly-rate'
            {...this.handleTextField('desiredHourlyRate', 'What would be your minimum desired hourly pay rate?')}
          />
          {
            script
            &&
            <div className='speaking-callout'>
            {this.props.labels.speakingCallout}
            </div>
          }

          <TextAreaItem {...this.handleTextArea('mostRecentWork', 'Tell me about your work at you most recent/current job.')} />
          <TextAreaItem {...this.handleTextArea('mostRecentWorkFirmType', 'Briefly describe for me the firm/company you are/were working for, for example, the size of the company, # of employees, # of offices, your department, the culture, etc.')} />
          <TextAreaItem {...this.handleTextArea('mostRecentWorkDuration', 'How long have you been doing this type of work?')} />
          <TextAreaItem {...this.handleTextArea('previousTypeOfWork', `Okay, that's great. What type of work did you do before that?`)} />
          <DropdownItem {...this.handleDropdown('hasWorkedRemotely', 'Have you ever had the opportunity to work remotely?', hasWorkedRemotelyMenuItems)} />

          {
            (this.getValue('hasWorkedRemotely') === true || (this.getValue('hasWorkedRemotely') && this.getValue('hasWorkedRemotely').id === true))
            &&
            <TextAreaItem {...this.handleTextArea('hasWorkedRemotelyComment', 'Please tell me about it.')} />
          }

          {
            (this.getValue('hasWorkedRemotely') === false || (this.getValue('hasWorkedRemotely') && this.getValue('hasWorkedRemotely').id === false))
            &&
            <TextAreaItem {...this.handleTextArea('hasWorkedRemotelyComment', 'How do you feel about working from home?')} />
          }


        </ul>
        {
          script
          &&
          <div>
            <div className='speaking-callout'>
              Do you have any questions that I might not have addressed?
            </div>
          </div>
        }
      </div>
    );
  }
}

function TextAreaItem(props) {

  const {text, ...otherProps} = props;

  return (
    <li className='instructions-list-item'>
        <div className='instructions-list-text'>{text}</div>
        <TextArea className='instructions-text-field' style={textFieldStyle} {...otherProps}/>
    </li>);
}

  function TextFieldItem(props) {

  const {text, ...otherProps} = props;

  return (
    <li className='instructions-list-item'>
        <div className='instructions-list-text'>{text}</div>
        <TextField className='instructions-text-field'  style={textFieldStyle}  {...otherProps} />
    </li>);
}

function DropdownItem(props) {

  const {text, ...otherProps} = props;

  return (
  <li className='instructions-list-item'>
        <div className='instructions-list-text'>{text}</div>
        <DropDownMenu className='instructions-dropdown'  {...dropDownCustomization} {...otherProps}  />
    </li>);
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Profile/f_ExplanationOfWahve/index.js